export default {
    namespaced: true,
    modules: {
        pages: require("./pages").default,
        projects: require("./projects").default,
        link: require("./link").default,
        excel: require("./excel").default,
        snackbar: require("./snackbar").default,
    },
    state: {
    },
};


// WEBPACK FOOTER //
// src/store/views/index.js